export default {
  textStyle: {
    fontWeight: "bold" as "bold",
  },
};
